
import { v4 as uuid } from 'uuid';
import { F05_ExportData } from '../pages/FrmCommonExport/F05_ExportManager';
import dayjs from 'dayjs';

export class F05Cache {

  static END_POINT = "f05_cache";

  serno = 0;
  guid;//= uuid();

  /** 紀錄時間 */
  rec_dt = "2999-01-01 00:00:00";
  
  /** 注意! 這裡是Web的 MemberGuid 與 後台的GUID不同，要改用 MemberCode 比對 */
  member_guid = "";

  json = "";

  constructor()
  {
    this.guid = uuid();
  }

  static new_F05Cache(member_guid: string, f05_data: F05_ExportData): F05Cache {
    const re = new F05Cache();

    re.guid = uuid();
    re.rec_dt = dayjs().format("YYYY-MM-DD HH:mm:ss");
    
    re.member_guid = member_guid;
    
    const data = new F05_Cache_Json(f05_data);// 轉換為欄位名稱較短的格式

    re.json = JSON.stringify(data);

    return re;
  }

}


/**
 * 匯出時，由 F05_ExportData 轉換為此格式，快取備用
 * 保存到 f05_cache 讓後台存取
 */
class F05_Cache_Json {

  constructor(f05_data: F05_ExportData) {
    
    this.填寫日期 = f05_data.填寫日期;

    this.項次 = f05_data.項次;

    this.廠區 = f05_data.廠區;
    this.部門代號 = f05_data.部門代號;
    this.部門名稱 = f05_data.部門名稱;

    this.工號 = f05_data.工號;
    this.姓名 = f05_data.姓名;
    this.健檢日期 = f05_data.健檢日期;

    this.性別 = f05_data.性別;

    //--------------------

    this.工作時數 = f05_data.工作時數_近6個月期間每月平均加班工時;
    this.是否符合 = f05_data.工作型態_工作型態以下選項是否有符合;

    this.Q1 = f05_data.Q1_工作型態_不規律的工作;
    this.Q2 = f05_data.Q2_工作型態_經常出差的工作;
    this.Q3 = f05_data.Q3_工作型態_異常溫度環境;
    this.Q4 = f05_data.Q4_工作型態_作業環境有噪音;
    this.Q5 = f05_data.Q5_工作型態_伴隨精神緊張的工作;
    this.Q6 = f05_data.Q6_工作型態_作業環境有時差;
   
  }

  // PROJECT_GUID = "";

  // MEMBER_GUID = "";
  // MemberCode = "";

   
  填寫日期 = "";

  項次 = "";

  廠區 = "";
  部門代號 = "";
  部門名稱 = "";

  工號 = "";
  姓名 = "";
  健檢日期 = "";

  性別 = "";

  //--------------------

  工作時數 = "";// 工作時數_近6個月期間每月平均加班工時
  是否符合 = "";// 工作型態_工作型態以下選項是否有符合

  Q1 = ""; // _工作型態_不規律的工作
  Q2 = ""; // _工作型態_經常出差的工作
  Q3 = "";// _工作型態_異常溫度環境
  Q4 = ""; // _工作型態_作業環境有噪音
  Q5 = ""; // _工作型態_伴隨精神緊張的工作
  Q6 = "";// _工作型態_作業環境有時差

}
